import { Box, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../../theme/theme';
import { SingleContractMetricResponse } from '../IMessageBubbleInterface';

import { CardFollowUp, CardHeaderRow, CardShell } from './sharedCardHelpers';

export const SingleContractMetricCard: React.FC<{
    singleContractMetric: SingleContractMetricResponse | null;
}> = ({ singleContractMetric }) => {
    if (!singleContractMetric) return null;

    return (
        <Box>
            <CardShell>
                <CardHeaderRow contractId={singleContractMetric.contractId} />

                <Box sx={{ p: 0.9 }}>
                    <Box sx={{ backgroundColor: colors.greyPreset[90], borderRadius: '8px', p: 0.85 }}>
                        <Typography
                            variant="body2"
                            sx={{ color: colors.greyPreset[40], fontSize: '0.72rem', fontWeight: 400 }}
                        >
                            {singleContractMetric.metricLabel}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: colors.fullBlack, fontWeight: 700, fontSize: '1.05rem', mt: 0.1 }}
                        >
                            {singleContractMetric.value}
                        </Typography>
                    </Box>
                </Box>
            </CardShell>

            <CardFollowUp text={singleContractMetric.followUp} />
        </Box>
    );
};
